import react from "react";

import RubinGlasswork1 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_001.jpeg";
import RubinGlasswork2 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_002.jpeg";
import RubinGlasswork3 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_003.jpeg";
import RubinGlasswork4 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_004.jpeg";
import RubinGlasswork5 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_005.jpeg";
import RubinGlasswork6 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_006.jpeg";
import RubinGlasswork7 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_007.jpeg";
import RubinGlasswork8 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_008.jpeg";
import RubinGlasswork9 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_009.jpeg";
import RubinGlasswork10 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_010.jpeg";
import RubinGlasswork11 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_011.jpeg";
import RubinGlasswork12 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_012.jpeg";
import RubinGlasswork13 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_013.jpeg";
import RubinGlasswork14 from "../images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_014.jpeg";

const RubinGlasswork = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={RubinGlasswork1} alt="Calliope Studio Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork2} alt="Calliope Studio Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork3} alt="Calliope Studio Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork4} alt="Calliope Studio Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork6} alt="Calliope Studio Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork5} alt="Calliope Studio Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork7} alt="Calliope Studio Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork8} alt="Calliope Studio Commercial Photography - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork9} alt="Calliope Studio Commercial Photography - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork10} alt="Calliope Studio Commercial Photography - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork11} alt="Calliope Studio Commercial Photography - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork12} alt="Calliope Studio Commercial Photography - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork13} alt="Calliope Studio Commercial Photography - Image 13"/>
                </div>
                <div className="single portrait">
                    <img src={RubinGlasswork14} alt="Calliope Studio Commercial Photography - Image 14"/>
                </div>
            </div>
        </div>
    );
}

export default RubinGlasswork;